import { memo, useMemo, useState } from "react";
import { Div, Pagination, useTheme, type Tab } from "react-better-html";

import { type ListRenderType } from "../types/app";
import { type PropertyFull } from "../types/property";
import { type Workspace } from "../types/workspace";
import { type ApiPagination } from "../types/api";

import { useQuery } from "../utils/hooks";
import { useI18n } from "../utils/i18n";

import BubbleTabs from "./common/BubbleTabs";
import WorkspacesList from "./workspaces/WorkspacesList";
import PropertiesList from "./properties/PropertiesList";

const listTypeName = "list-type";
const viewTypeName = "view-type";

const possibleListTypes: string[] = ["folder-view", "flat-list"];
const possibleListViewOptions: ListRenderType[] = ["grid", "list"];

type PropertiesWorkspacesListProps = {
   page?: number;
   properties?: ApiPagination<PropertyFull>;
   workspaces?: Workspace[];
   onChangePage?: (page: number) => void;
   getSinglePropertyUrl?: React.ComponentProps<typeof PropertiesList>["getSinglePropertyUrl"];
};

function PropertiesWorkspacesList({
   page = 1,
   properties,
   workspaces,
   onChangePage,
   getSinglePropertyUrl,
}: PropertiesWorkspacesListProps) {
   const theme = useTheme();
   const { t } = useI18n();
   const query = useQuery();

   const [listType, _] = useState<string>(
      query[listTypeName] && possibleListTypes.includes(query[listTypeName]) ? query[listTypeName] : "folder-view",
   );
   const [viewType, setViewType] = useState<ListRenderType>(
      query[viewTypeName] && possibleListViewOptions.includes(query[viewTypeName] as ListRenderType)
         ? (query[viewTypeName] as ListRenderType)
         : "grid",
   );

   // const flatListTabs = useMemo<Tab[]>(
   //    () => [
   //       {
   //          id: "folderView",
   //          label: t((l) => l.pages.properties.folderView),
   //       },
   //       {
   //          id: "flatList",
   //          label: t((l) => l.pages.properties.flatList),
   //       },
   //    ],
   //    [t],
   // );
   const renderTypeTabs = useMemo<Tab[]>(
      () => [
         {
            id: "grid" as ListRenderType,
            label: t((l) => l.common.grid),
         },
         {
            id: "list" as ListRenderType,
            label: t((l) => l.common.list),
         },
      ],
      [t],
   );
   return (
      <Div.column width="100%" gap={theme.styles.space}>
         <Div.row alignItems="center" gap={theme.styles.gap}>
            {/* <BubbleTabs tabs={flatListTabs} name={listTypeName} onChange={setListType} /> */}
            <BubbleTabs tabs={renderTypeTabs} name={viewTypeName} onChange={setViewType as any} />
         </Div.row>

         {workspaces && (
            <>
               <WorkspacesList
                  workspaces={workspaces}
                  renderType={viewType}
                  flatList={listType === "flat-list"}
                  noLoading={properties !== undefined}
                  noEmptyState={properties !== undefined}
               />
            </>
         )}

         {properties && (
            <>
               <PropertiesList
                  properties={properties.items}
                  renderType={viewType}
                  flatList={listType === "flat-list"}
                  getSinglePropertyUrl={getSinglePropertyUrl}
               />

               {properties.total > properties.pageSize && (
                  <Pagination
                     currentPage={page}
                     itemsPerPage={properties.pageSize}
                     pageCount={Math.ceil(properties.total / properties.pageSize)}
                     onChangePage={onChangePage}
                  />
               )}
            </>
         )}
      </Div.column>
   );
}

export default memo(PropertiesWorkspacesList);
